import { render, staticRenderFns } from "./header-logo.vue?vue&type=template&id=3d1a36c1&"
import script from "./header-logo.vue?vue&type=script&lang=js&"
export * from "./header-logo.vue?vue&type=script&lang=js&"
import style0 from "./header-logo.vue?vue&type=style&index=0&id=3d1a36c1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports